const images = {
	logo: require('~/assets/images/logo.png'),
	noImage : require('~/assets/images/no-image.jpg'),
	manAcademic: require('~/assets/images/avatar/avatar-giao-vu-nam.png'),
	womanAcademic: require('~/assets/images/avatar/avatar-giao-vu-nu.png'),
	manStudent: require('~/assets/images/avatar/avatar-hoc-vien-nam.png'),
	womanStudent: require('~/assets/images/avatar/avatar-hoc-vien-nu.png'),
	manTeacher: require('~/assets/images/avatar/avatar-giao-vu-nam.png'),
	womanTeacher: require('~/assets/images/avatar/avatar-giao-vu-nu.png'),
	manParent: require('~/assets/images/avatar/avatar-phu-huynh-nam.webp'),
	womanParent: require('~/assets/images/avatar/avatar-phu-huynh-nu.webp'),
}
export default images
